import {
    addYears as dateFnsAddYears,
    differenceInCalendarDays as dateFnsDifferenceInCalendarDays,
    differenceInHours as dateFnsDifferenceInHours,
    endOfMonth as dateFnsEndOfMonth,
    endOfYear as dateFnsEndOfYear,
    format as dateFnsFormat,
    startOfYear as dateFnsStartOfYear,
    toDate as dateFnsToDate
} from 'date-fns'

import { enGB } from 'date-fns/locale'

const addYears = function (date, amount) {
    return dateFnsAddYears(date, amount, {
        locale: enGB
    })
}

const differenceInDays = function (date1, date2) {
    return dateFnsDifferenceInCalendarDays(date1, date2, {
        locale: enGB
    })
}

const differenceInHours = function (date1, date2) {
    return dateFnsDifferenceInHours(date1, date2, {
        locale: enGB
    })
}

const endOfMonth = function (date) {
    return dateFnsEndOfMonth(date, {
        locale: enGB
    })
}

const endOfYear = function (date) {
    return dateFnsEndOfYear(date, {
        locale: enGB
    })
}

const format = function (date, formatStr) {
    return dateFnsFormat(date, formatStr, {
        awareOfUnicodeTokens: true,
        locale: enGB
    })
}

const startOfYear = function (date) {
    return dateFnsStartOfYear(date, {
        locale: enGB
    })
}

const toDate = function (date) {
    const containsTime = /([+-]?\d\d):(\d\d)$/.exec(date)

    if (!containsTime) {
        date = date + 'T00:00:00'
    }

    return dateFnsToDate(new Date(date), {
        locale: enGB
    })
}

export { addYears, differenceInDays, differenceInHours, endOfMonth, endOfYear, format, startOfYear, toDate }